import React, { useRef } from 'react'
import GenericIconButton from '../../../../../common/components/actions/genericIconButton'

export function ItemGridWidgetGallery({
    openEditor,
    deleteWidget,
    movementIconIsFocus,
    openMovimentModal
}: {
    movementIconIsFocus: boolean
    openEditor: () => void
    deleteWidget: () => void
    openMovimentModal:(element:Element) => void
}) {
    const el = useRef()
    return (
        <div className="widgetGallery--grid__widgetContainer--actions" ref={el}>
            <GenericIconButton icon="far fa-edit" onClick={openEditor} />

            <GenericIconButton
                icon="fas fa-arrows-alt"               
                selected={movementIconIsFocus}                
                onClick={event => {                                        
                    if (el.current) {
                        const element = el.current as Element
                        openMovimentModal(element)
                    }
                }}
            />

            <GenericIconButton bsStyle="danger" icon="far fa-trash-alt" onClick={deleteWidget} />
        </div>
    )
}
